import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 0 0 ", "px ", "px;\n  box-shadow: ", ";\n  font-size: ", "px;\n  position: relative;\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { property, typography, color, zIndex } from '@scp/ui-shared/theme/variables';
/**
 * Component that is used in other components where dropdown is needed (for example SelectField and AutoCompleteField).
 *
 * @example ./__docs__/Dropdown.md
 */

export var Dropdown = styled.div(_templateObject(), color.background, property.borderRadius, property.borderRadius, property.boxShadow, typography.defaultFontSize, zIndex.dropdown);